import React from 'react';
import {Stack, Typography, IconButton} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export const NavigationControls = ({
  onBack,
  onNext,
  showBack = true,
  showNext = true,
  backLabel = 'Back',
  nextLabel = 'Next',
  config = {},
}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{width: '100%', padding: '8px 0'}}>
      {showBack && (
        <Stack direction="row" alignItems="center" onClick={onBack} sx={{cursor: 'pointer'}}>
          {config.backButton || (
            <>
              <ArrowBackIcon sx={{color: config.colors?.primary || '#35C6C9'}} />
              <Typography
                sx={{
                  ml: 1,
                  color: config.colors?.primary || '#35C6C9',
                  fontWeight: 600,
                }}
              >
                {backLabel}
              </Typography>
            </>
          )}
        </Stack>
      )}

      {showNext && (
        <Stack direction="row" alignItems="center" onClick={onNext} sx={{cursor: 'pointer'}}>
          <Typography
            sx={{
              mr: 1,
              color: config.colors?.primary || '#35C6C9',
              fontWeight: 600,
            }}
          >
            {nextLabel}
          </Typography>
          <ArrowForwardIcon sx={{color: config.colors?.primary || '#35C6C9'}} />
        </Stack>
      )}
    </Stack>
  );
};
